export default "__VITE_ASSET__234aed97__"